import PortalGerenciadorDePerfis from "components/Formulario/Components/SubComponents/PortalGerenciadorDePerfis";

export const InputTableModalPerfisDeAcesso = (perfisAcessoDataSource, listaDireitos=[], listaPerfisAcesso=[], referenciaObjetoVisual=null) => {
  
    const colunasTabelasGerenciarAcessos = [
        {
          title: 'Contrato de Serviço',
          width: '250px',
          render: (_, record) => {
            return(
              `${record.direito.label}`
            )
          },
        },
        {
          title: 'Perfil de Acesso',
          width: '100px',
          render: (_, record) => {
            return(
              `${record.perfil.label}`
            )
          }
        }
    ];

    return ({
    input: {
      name: "perfisAcesso",
      label: "Configurar Perfis de Acesso",
      rules: [{
        required: true,
        message: "Campo obrigatório"
      }],
      type: "table",
    },
    dataSource: perfisAcessoDataSource ?? [],
    columns: colunasTabelasGerenciarAcessos,
    collapse: {
      open: true,
      ref: referenciaObjetoVisual
    },
    container: {
      tituloBotao: "Novo Perfil",
      containerSettings: {
        containerType: "modal",
        content: {
          contentType: "customForm",
          props:{
            data: {
              listaPerfisAcesso: listaPerfisAcesso,
              listaDireitos: listaDireitos
            }
          },
          formCustomComponent: <PortalGerenciadorDePerfis />
        }
      }
    },
    colSpan: 24,
    divider: {
      before: {
        show: true
      }
    }
  })
}